export enum QualtricsSurveyCookie {
  isBtnSatisfactionSurvey = 'isBtnSatisfactionSurvey'
}
